<template>
  <div class="main tabs_main">
    <div class="main_header">
      <div class="header_item">
        <span style="color: #fff;">楼号：</span>
        <el-select v-model="buildId" :size="size" clearable placeholder="请选择楼号">
          <el-option
            v-for="item in buildData"
            :key="item.buildId"
            :label="item.buildNum"
            :value="item.buildId">
          </el-option>
        </el-select>
      </div>
      <div class="header_item">
        <el-button icon="el-icon-search" @click="searchBuildingnoList(true)">查询</el-button>
        <el-button class="search_btn" icon="el-icon-plus" @click="propInsert()">新增</el-button>
      </div>
    </div>
    <div class="main_content">
      <el-table
        v-loading="loading"
        :data="buildingnoList"
        height="100%">
        <el-table-column label="序号" width="100" align="center">
          <template #default="scope">
            <span>{{(pageNum - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="buildNum" label="楼号" align="center"></el-table-column>
        <el-table-column label="操作" align="center" width="200">
          <template #default="{ row }">
            <el-button class="table_btn" size="mini" v-if="showButton('update')" @click="propUpdate(row)">修改</el-button>
            <el-button class="delete_btn" size="mini" v-if="showButton('delete')" @click="deleteInfo(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="main_footer">
      <el-pagination
        background
        @current-change="changePageNum"
        @size-change="changePageSize"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 添加楼号 修改楼号信息 -->
    <el-dialog
      class="prop_dialog"
      :title="asyncTitle ? '添加楼号' : '修改楼号信息'"
      :visible.sync="asyncBuildingno"
      width="35%">
      <el-form ref="form" :model="formBuildingno" :rules="rulesBuildingno" label-width="auto" class="rule_form">
        <el-form-item label="楼号：" prop="buildNum">
          <el-input
            v-model="formBuildingno.buildNum" 
            :size="size"
            clearable=""
            placeholder="请输入楼号">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="asyncBuildingno = false">取 消</el-button>
        <el-button class="submit_btn" @click="asyncTitle ? submitInsertForm() : submitUpdateForm()">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { buttonPinia } from "../../../../pinia/index";
import { changeSize, throttle } from "../../../../plugins/public";
  export default {
    name: 'BuildingnoIndex',
    data() {
      return {
        buildId: '',
        buildData: [],
        size: changeSize(),
        pageNum: 1,
        pageSize: 10,
        total: 1,
        loading: true,
        buildingnoList: [], // 列表信息
        asyncTitle: true, // true 新增楼号 false 修改楼号信息
        asyncBuildingno: false, // 弹窗
        formBuildingno: {}, // 表单信息
        rulesBuildingno: {
          buildNum: [{
            required: true,
            message: '请输入楼号',
            trigger: 'blur'
          }]
        }, // 表单校验规则
      }
    },
    mounted() {
      const that = this;
      // 根据窗口大小动态修改组件尺寸
      window.onresize = () => {
        that.size = changeSize();
      }
      that.getAllBuildData();
      that.searchBuildingnoList(true);
    },
    methods: {
      // 获取全部楼号信息
      async getAllBuildData() {
        const { data } = await this.$api.Basics.GETALLBUILDDATA();
        this.buildData = data;
      },
      // 查询列表信息
      searchBuildingnoList(bol) {
        if(bol) {
          this.pageNum = 1;
        }
        this.$api.Basics.SEARCHBUILDINGNOLIST({
          buildId: this.buildId,
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }).then((res) => {
          if(res.success) {
            this.total = res.data.total;
            this.buildingnoList = res.data.list;
          }
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        })
      },
      // 打开添加信息
      propInsert() {
        this.asyncTitle = true;
        this.asyncBuildingno = true;
      },
      // 打开修改信息
      propUpdate(row) {
        this.asyncTitle = false;
        this.asyncBuildingno = true;
        this.$set(this.formBuildingno, 'buildId', row.buildId);
        this.$set(this.formBuildingno, 'buildNum', row.buildNum);
      },
      // 删除备品备件信息
      deleteInfo(row) {
        this.$confirm("该操作将删除该楼号信息，是否继续删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
       })
       .then(() => {
         this.$api.Basics.DELETEBUILDINGNOINFO({buildId: row.buildId})
        .then(res => {
          if(res.success) {
            this.searchBuildingnoList(true);
            this.$message.success("删除成功！");
          } else {
            this.$message.warning(res.statusMsg);
          }
        })
       })
       .catch(() => {
         this.$message.warning("您已取消");
       })
      },
      // 提交添加信息
      submitInsertForm: throttle(function() {
        this.$refs.form.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.formBuildingno);
            this.$api.Basics.INSERTBUILDINGNOINFO(params).then((res) => {
              if(res.success) {
                this.asyncBuildingno = false;
                this.$message.success('添加成功!');
                this.searchBuildingnoList(true);
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 提交修改信息
      submitUpdateForm: throttle(function() {
        this.$refs.form.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.formBuildingno);
            this.$api.Basics.UPDATEBUILDINGNOINFO(params).then((res) => {
              if(res.success) {
                this.asyncBuildingno = false;
                this.$message.success('修改成功!');
                this.searchBuildingnoList(true);
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 切换页码
      changePageNum(page) {
        this.pageNum = page;
        this.searchBuildingnoList();
      },
      // 切换每页条数
      changePageSize(size) {
        this.pageSize = size;
        this.searchBuildingnoList();
      },
      // 判断按钮权限信息
      showButton(str) {
        const pinia = buttonPinia();
        return pinia.$state.buttonInfo.includes(str);
      },
    },
    watch: {
      asyncBuildingno(bol) {
        if(!bol) {
          this.formBuildingno = {};
          this.$refs.form.resetFields();
        }
      },
      total() {
        this.getAllBuildData();
      }
    }
  }
</script>

<style lang="scss" scoped>
@import '../../../../style/layout-main.scss';
</style>